module.exports = __webpack_public_path__ + "img/4674da9.jpg";